import { render, staticRenderFns } from "./CrearDisclaimer.vue?vue&type=template&id=6796d17b"
import script from "./CrearDisclaimer.vue?vue&type=script&lang=js"
export * from "./CrearDisclaimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports